<template>
  <div class="wrapper">
    <div class="page-header">
      <div class="page-ribbon">
        <div class="path">
          <img
            src="@/assets/admin-icon/pitch-active.svg"
          /><pathViewer></pathViewer>
        </div>
        <div class="ribbon-options"></div>
      </div>
    </div>

    <div class="page-body">
      <Pitches></Pitches>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import Pitches from "@/components/Company/Pitches.vue";
export default {
  name: "dashboard",
  components: {
    Pitches,
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {
    let vm = this;
    let path = [
      {
        label: "Pitches",
        active: true,
      },
    ];
    vm.$store.commit("SET_PATH", path);
  },
  methods: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  .page-header {
    background: #dfdfdf;
    .page-ribbon {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 41px;
      padding: 0px 15px;
      background: #fff;
      .path {
        color: #0884af;
        font-size: 13px;
        display: flex;
        align-items: center;
        img {
          width: 20px;
          margin-right: 6px;
        }
        span {
          margin-top: 4px;
        }
      }
      .ribbon-options {
        display: flex;
        align-items: center;
        .btn-search {
          border: none;
          background: transparent;
          img {
            width: 13px;
            object-fit: contain;
          }
        }
        .btn-customer-user {
          background: transparent;
          border: none;
          display: flex;
          align-items: center;
          .profile-logo {
            width: 15px;
            height: 15px;
            object-fit: cover;
            border-radius: 50%;
            margin-right: 5px;
          }
          span {
            margin-right: 5px;
          }
        }
      }
    }
    .page-options {
      display: flex;
      padding: 6px 15px;
      background: #d0d0d0;
      min-height: 50px;
      .btn-option {
        background: transparent;
        color: #000;
        border: none;
        padding: 10px 30px;
        border-radius: 5px;
        cursor: pointer;
        outline: none;
        &.active {
          background: #fff;
          color: #0884af;
        }
      }
    }
  }
  .page-body {
    height: calc(100% - 40px);
    background: #fff;
    padding: 10px 10px;
    display: flex;
    flex-direction: column;
  }
}
</style>
